// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*

This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 

is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.

*/

.textbox .rowWiseControl {
  display: flex;
  flex-direction: row;
  /* gap: 1em; */
}

.textbox .colWiseControl {
  /* gap: 1em;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap; */

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 9px;
  /* margin: auto; */
}

.textbox .controlLabelDiv,
.textbox .MuiFormLabel-root,
.textbox .MuiFormLabel-root.Mui-focused {
  font-family: var(--default-FontName);
  font-size: var(--label-FontSize);
  font-weight: var(--label-FontWeight);
  color: var(--label-FontColour);
  line-height: normal;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 100px;
  gap: 1%;
}

.textbox .MuiInputBase-input::placeholder {
  font-family: var(--default-FontName);
  font-size: var(--label-FontSize);
  font-weight: var(--label-FontWeight);
  color: var(--placeHolderColor);
  opacity: 1;
  transition: unset;
}

.text-field-container {
  height: 100%;
}

.AdditionalTab .controlLabelDiv {
  width: 100%;
}

.contraventionsection .textbox .controlLabelDiv {
  font-weight: var(--header-FontWeight);
}

.textbox .iconPadding {
  height: 16px;
  width: 16px;
}

/* CUSTOM CSS   */

.textbox .MuiFormControl-root .MuiFormLabel-root {
  position: relative;
  transform: inherit;
}

.textbox .MuiFormControl-root .MuiInputBase-root {
  margin-top: 0px;
}

.textbox .MuiInputBase-root:before {
  border-bottom: none;
}

.textbox .MuiInputBase-root:after {
  border-bottom: none;
}

.textbox .MuiInputBase-root {
  background-color: var(--gridbgcolor);
  /* border: 1px solid var(--controlborder-colour); */
  border-radius: 4px;
  box-sizing: border-box;
  height: 35px;
  /* padding: 15px 10px 15px; */
  padding: 0px 0px 0px 15px;
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
  text-align: var(--textahrlignment);
  letter-spacing: var(--font-letter-space);
  width: 100%;
}

.textbox .MuiInputBase-root:not(.Mui-disabled):hover:before {
  border-bottom: none;
}

.textbox .MuiInputBase-input {
  padding: 1px;
}

.textbox .capsLock .MuiInputBase-input {
  text-transform: uppercase;
}

.textbox .outlineError .MuiInputBase-root {
  border: 1px solid var(--required-color) !important;
  border-radius: 4px;
}

/* added css for disabled control validation alert */
.textbox .MuiFormHelperText-root,
.textbox .Mui-disabled.MuiFormHelperText-root {
  color: var(--required-color);
  font-family: var(--default-FontName);
  font-size: var(--fieldAlertFontSize);
  font-weight: var(--default-FontWeight);
  width: 100%;
  margin-top: -3px;
}

/*For auto fill input*/
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: var(--default-FontColour);
  -webkit-box-shadow: 0 0 0 1000px var(--gridbgcolor) inset !important;
  transition: background-color 300ms ease-in-out 0s;
}

@media (min-width: 300px) and (max-width: 900px) {
  .textbox .colWiseControl {
    display: flex;
    flex-direction: column;
    margin: auto;
    gap: 11px;
  }
}

@media (min-width: 520px) and (max-width: 700px) {
  .textbox .controlLabelDiv,
  .textbox .MuiFormLabel-root,
  .textbox .MuiFormLabel-root.Mui-focused {
    font-family: var(--labelFontName);
    font-size: var(--labelFontSize);
    font-weight: var(--labelFontWeight);
    color: var(--labelFontColor);
    line-height: var(--labelFontName);
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 40%;
  }
}

.contraventionmultilinedescription .MuiInputBase-root.MuiInput-root {
  height: 100%;
}

.homepagetoolsection .textbox .rowWiseControl {
  flex-direction: column-reverse;
}

.homepagetoolsection .textbox .MuiInputBase-root {
  background-color: var(--ToolbarBackgroundColour);
}

.homepagetoolsection .textbox,
.homepagetoolsection .textbox .MuiSvgIcon-root {
  cursor: pointer;
}

.NotesTab .MuiInputBase-root.MuiInput-root {
  height: 100%;
}

.NotesTab #txt_notesdescription {
  padding-top: 10px;
  height: 115px !important;
  overflow: auto !important;
}

textarea#txt_notesdescription {
  height: 123px;
  overflow: hidden;
}

.MuiInputBase-root.MuiInput-root.Mui-disabled {
  background-color: var(--inputControlDisabledBgColor);
  pointer-events: none;
  color: var(--inputControlDisabledTextColor);
  border-bottom-style: none;
}

.textbox .MuiInputBase-root.MuiInput-root.Mui-disabled:before {
  border-bottom-style: none;
}

.Required-color {
  color: var(--required-color);
}

.InputAdornmentText {
  color: var(--font-disabled-colour);
  margin-top: -1px;
  /* height: 100%; */
}

.InputAdornmentText.currencySymbol {
  color: var(--default-FontColour);
  margin-top: unset;
}

.textbox .MuiInputBase-root.MuiInput-root.Mui-disabled {
  background-color: var(--inputControlDisabledBgColor) !important;
  pointer-events: none !important;
  color: var(--inputControlDisabledTextColor) !important;
}

.textbox .Mui-disabled .InputAdornmentText.currencySymbol {
  color: var(--inputControlDisabledTextColor);
}

.textbox .MuiInputBase-input.Mui-disabled {
  -webkit-text-fill-color: unset;
}

.InputAdornmentText img {
  /* height: var(--inputadornmenttextheight); */
  height: var(--default-FontSize);
  margin-top: 7px;
}

/* .contraventiondatasection .textbox .MuiInputBase-input {
  padding: unset;
} */

@media (max-width: 900px) {
  .contraventiondatasection .textbox .MuiInputBase-input {
    height: 100%;
  }
}

.userDataSection .roleSetup .textbox .MuiInputBase-root,
.userDataSection .personalData .textbox .MuiInputBase-root {
  background-color: var(--ToolbarBackgroundColour);
  border: 1px solid var(--inputControlBorderColor);
}

@media (min-width: 100px) and (max-width: 901px) {
  .userDataSection .roleSetup .textbox .MuiInputBase-root,
  .userDataSection .personalData .textbox .MuiInputBase-root {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    align-content: center;
  }
}

.textbox .controlLabelDiv .withSubTextSection {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.textbox .text-field-container .multiLineLabel {
  display: flex;
  align-items: center;
}

.textbox .additionalFieldSection {
  font-size: var(--airaLabelFontSize);
  color: var(--button-color);
  font-weight: var(--header-FontWeight);
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/textBox/TextBox.css"],"names":[],"mappings":"AAAA;;;;;;CAMC;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;;;oBAGkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,iBAAiB;;AAEjB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,gCAAgC;EAChC,kCAAkC;EAClC,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;;EAEE,4BAA4B;EAC5B,oCAAoC;EACpC,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;;;;;;;;;EASE,kDAAkD;EAClD,oEAAoE;EACpE,iDAAiD;AACnD;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAS;EACX;AACF;;AAEA;EACE;;;IAGE,iCAAiC;IACjC,+BAA+B;IAC/B,mCAAmC;IACnC,4BAA4B;IAC5B,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,oBAAoB;EACpB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,+DAA+D;EAC/D,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE;IACE,YAAY;EACd;AACF;;AAEA;;EAEE,gDAAgD;EAChD,gDAAgD;AAClD;;AAEA;EACE;;IAEE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,qCAAqC;AACvC","sourcesContent":["/*\n\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \n\nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n\n*/\n\n.textbox .rowWiseControl {\n  display: flex;\n  flex-direction: row;\n  /* gap: 1em; */\n}\n\n.textbox .colWiseControl {\n  /* gap: 1em;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap; */\n\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  gap: 9px;\n  /* margin: auto; */\n}\n\n.textbox .controlLabelDiv,\n.textbox .MuiFormLabel-root,\n.textbox .MuiFormLabel-root.Mui-focused {\n  font-family: var(--default-FontName);\n  font-size: var(--label-FontSize);\n  font-weight: var(--label-FontWeight);\n  color: var(--label-FontColour);\n  line-height: normal;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  min-width: 100px;\n  gap: 1%;\n}\n\n.textbox .MuiInputBase-input::placeholder {\n  font-family: var(--default-FontName);\n  font-size: var(--label-FontSize);\n  font-weight: var(--label-FontWeight);\n  color: var(--placeHolderColor);\n  opacity: 1;\n  transition: unset;\n}\n\n.text-field-container {\n  height: 100%;\n}\n\n.AdditionalTab .controlLabelDiv {\n  width: 100%;\n}\n\n.contraventionsection .textbox .controlLabelDiv {\n  font-weight: var(--header-FontWeight);\n}\n\n.textbox .iconPadding {\n  height: 16px;\n  width: 16px;\n}\n\n/* CUSTOM CSS   */\n\n.textbox .MuiFormControl-root .MuiFormLabel-root {\n  position: relative;\n  transform: inherit;\n}\n\n.textbox .MuiFormControl-root .MuiInputBase-root {\n  margin-top: 0px;\n}\n\n.textbox .MuiInputBase-root:before {\n  border-bottom: none;\n}\n\n.textbox .MuiInputBase-root:after {\n  border-bottom: none;\n}\n\n.textbox .MuiInputBase-root {\n  background-color: var(--gridbgcolor);\n  /* border: 1px solid var(--controlborder-colour); */\n  border-radius: 4px;\n  box-sizing: border-box;\n  height: 35px;\n  /* padding: 15px 10px 15px; */\n  padding: 0px 0px 0px 15px;\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n  text-align: var(--textahrlignment);\n  letter-spacing: var(--font-letter-space);\n  width: 100%;\n}\n\n.textbox .MuiInputBase-root:not(.Mui-disabled):hover:before {\n  border-bottom: none;\n}\n\n.textbox .MuiInputBase-input {\n  padding: 1px;\n}\n\n.textbox .capsLock .MuiInputBase-input {\n  text-transform: uppercase;\n}\n\n.textbox .outlineError .MuiInputBase-root {\n  border: 1px solid var(--required-color) !important;\n  border-radius: 4px;\n}\n\n/* added css for disabled control validation alert */\n.textbox .MuiFormHelperText-root,\n.textbox .Mui-disabled.MuiFormHelperText-root {\n  color: var(--required-color);\n  font-family: var(--default-FontName);\n  font-size: var(--fieldAlertFontSize);\n  font-weight: var(--default-FontWeight);\n  width: 100%;\n  margin-top: -3px;\n}\n\n/*For auto fill input*/\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  -webkit-text-fill-color: var(--default-FontColour);\n  -webkit-box-shadow: 0 0 0 1000px var(--gridbgcolor) inset !important;\n  transition: background-color 300ms ease-in-out 0s;\n}\n\n@media (min-width: 300px) and (max-width: 900px) {\n  .textbox .colWiseControl {\n    display: flex;\n    flex-direction: column;\n    margin: auto;\n    gap: 11px;\n  }\n}\n\n@media (min-width: 520px) and (max-width: 700px) {\n  .textbox .controlLabelDiv,\n  .textbox .MuiFormLabel-root,\n  .textbox .MuiFormLabel-root.Mui-focused {\n    font-family: var(--labelFontName);\n    font-size: var(--labelFontSize);\n    font-weight: var(--labelFontWeight);\n    color: var(--labelFontColor);\n    line-height: var(--labelFontName);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    min-width: 40%;\n  }\n}\n\n.contraventionmultilinedescription .MuiInputBase-root.MuiInput-root {\n  height: 100%;\n}\n\n.homepagetoolsection .textbox .rowWiseControl {\n  flex-direction: column-reverse;\n}\n\n.homepagetoolsection .textbox .MuiInputBase-root {\n  background-color: var(--ToolbarBackgroundColour);\n}\n\n.homepagetoolsection .textbox,\n.homepagetoolsection .textbox .MuiSvgIcon-root {\n  cursor: pointer;\n}\n\n.NotesTab .MuiInputBase-root.MuiInput-root {\n  height: 100%;\n}\n\n.NotesTab #txt_notesdescription {\n  padding-top: 10px;\n  height: 115px !important;\n  overflow: auto !important;\n}\n\ntextarea#txt_notesdescription {\n  height: 123px;\n  overflow: hidden;\n}\n\n.MuiInputBase-root.MuiInput-root.Mui-disabled {\n  background-color: var(--inputControlDisabledBgColor);\n  pointer-events: none;\n  color: var(--inputControlDisabledTextColor);\n  border-bottom-style: none;\n}\n\n.textbox .MuiInputBase-root.MuiInput-root.Mui-disabled:before {\n  border-bottom-style: none;\n}\n\n.Required-color {\n  color: var(--required-color);\n}\n\n.InputAdornmentText {\n  color: var(--font-disabled-colour);\n  margin-top: -1px;\n  /* height: 100%; */\n}\n\n.InputAdornmentText.currencySymbol {\n  color: var(--default-FontColour);\n  margin-top: unset;\n}\n\n.textbox .MuiInputBase-root.MuiInput-root.Mui-disabled {\n  background-color: var(--inputControlDisabledBgColor) !important;\n  pointer-events: none !important;\n  color: var(--inputControlDisabledTextColor) !important;\n}\n\n.textbox .Mui-disabled .InputAdornmentText.currencySymbol {\n  color: var(--inputControlDisabledTextColor);\n}\n\n.textbox .MuiInputBase-input.Mui-disabled {\n  -webkit-text-fill-color: unset;\n}\n\n.InputAdornmentText img {\n  /* height: var(--inputadornmenttextheight); */\n  height: var(--default-FontSize);\n  margin-top: 7px;\n}\n\n/* .contraventiondatasection .textbox .MuiInputBase-input {\n  padding: unset;\n} */\n\n@media (max-width: 900px) {\n  .contraventiondatasection .textbox .MuiInputBase-input {\n    height: 100%;\n  }\n}\n\n.userDataSection .roleSetup .textbox .MuiInputBase-root,\n.userDataSection .personalData .textbox .MuiInputBase-root {\n  background-color: var(--ToolbarBackgroundColour);\n  border: 1px solid var(--inputControlBorderColor);\n}\n\n@media (min-width: 100px) and (max-width: 901px) {\n  .userDataSection .roleSetup .textbox .MuiInputBase-root,\n  .userDataSection .personalData .textbox .MuiInputBase-root {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n    align-content: center;\n  }\n}\n\n.textbox .controlLabelDiv .withSubTextSection {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.textbox .text-field-container .multiLineLabel {\n  display: flex;\n  align-items: center;\n}\n\n.textbox .additionalFieldSection {\n  font-size: var(--airaLabelFontSize);\n  color: var(--button-color);\n  font-weight: var(--header-FontWeight);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
